import { AppBarEvents } from "@1js/office-start-appbar-events";
import { useNovaEventing } from "@nova/react";
import React from "react";
/**
 * Props for the AppBarRenderError control
 */
interface AppBarRenderErrorProps {
  error: Error | undefined;
  errorInfo: React.ErrorInfo | undefined;
  boundarySource: string;
}
export const AppBarRenderError: React.FC<AppBarRenderErrorProps> = (props) => {
  const novaEventing = useNovaEventing();
  React.useEffect(() => {
    // Fire a Nova event
    const appBarRenderErrorEvent = AppBarEvents.renderError(() => {
      const error = {
        name: `${props.boundarySource}::${props.error?.name}`,
        message: props.error?.message || "Unknown error",
        stack: props.error?.stack,
      };
      return {
        error: error,
        errorInfo: props.errorInfo,
      };
    });
    novaEventing.generateEvent({
      event: appBarRenderErrorEvent,
    });
  }, [novaEventing, props.boundarySource, props.error, props.errorInfo]);
  return null;
};
